import { render, staticRenderFns } from "./DialogNovoContato.vue?vue&type=template&id=6aa55e68"
import script from "./DialogNovoContato.vue?vue&type=script&lang=js"
export * from "./DialogNovoContato.vue?vue&type=script&lang=js"
import style0 from "./DialogNovoContato.vue?vue&type=style&index=0&id=6aa55e68&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports